import React from 'react';
import useAppContext from '../../hooks/context/useAppContext';
import SectionHeader from '../../components/SectionHeader/SectionHeader';
import { DashboardStateProvider } from './store/dashboardStore';
import DashboardComponent from './components/Dashboard';
import ProductPrices from '../PublicProductPricesPage/components/ProductPrices/ProductPrices';
import userRoles from '../../constants/userRoles';
import { FormattedMessage } from 'react-intl';

const CustomerDashboard = () => {
  const { getCustomerIds, getUserRole } = useAppContext();
  const role = getUserRole();
  const customerIds = getCustomerIds();
  const allowedForRoles = [userRoles.ADMIN, userRoles.TRADER, userRoles.KAM, userRoles.ASM, userRoles.CUSTOMER_MULTIPLE_COTRACTS,
    userRoles.CUSTOMER_VIEWER_MULTIPLE_COTRACTS];

  const showDashboard =
    ((role === userRoles.CUSTOMER_VIEWER || role === userRoles.CUSTOMER) && customerIds?.length > 0) ||
    allowedForRoles.indexOf(role) !== -1;

  return (
    showDashboard ?
      <DashboardStateProvider>
        <DashboardComponent />
      </DashboardStateProvider> :
      <>
        <SectionHeader>
          <FormattedMessage id={'app.publicProductPrices.sectionTitle'} />
        </SectionHeader>
        <ProductPrices />
      </>
  );
};

export default CustomerDashboard;
